import { render, staticRenderFns } from "./EmployeeLogin.vue?vue&type=template&id=49584a03&scoped=true"
import script from "./EmployeeLogin.vue?vue&type=script&lang=js"
export * from "./EmployeeLogin.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLogin.vue?vue&type=style&index=0&id=49584a03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49584a03",
  null
  
)

export default component.exports